<template>
  <div class="profile-page">
    <b-row>
      <b-col md="12">
        <h3>Profile Details</h3>
      </b-col>
    </b-row>
    <!-- Toggler bar for smaller screens -->
    <b-row class="toggler-bar d-md-none">
      <b-col>
        <b-button
          @click="toggleSidebar"
          variant="primary"
          :class="{ 'move-top-right': isSidebarVisible }"
          class="toggle-btn"
        >
          <i :class="isSidebarVisible ? 'fas fa-times' : 'fas fa-bars'"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="content-wrapper">
      <!-- Sidebar -->
      <b-col
        md="3"
        class="sidebar-wrapper"
        :class="{ 'd-none': !isSidebarVisible && !isDesktop }"
      >
        <div class="sidebar-content">
          <profile />
        </div>
      </b-col>
      <!-- Scrollable content -->
      <b-col md="9" class="scrollable-content">
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import profile from "@/components/profile/profileCategory";
export default {
  components: {
    profile,
  },
  data() {
    return {
      isSidebarVisible: false,
      isDesktop: window.innerWidth >= 768,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 768;
      if (this.isDesktop) {
        this.isSidebarVisible = true;
      } else {
        this.isSidebarVisible = false;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.profile-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content-wrapper {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.toggler-bar {
  margin-bottom: 10px;
}

.sidebar-wrapper {
  max-height: 90vh;
  overflow-y: auto;
}

.sidebar-wrapper::-webkit-scrollbar {
  width: 8px;
}

.sidebar-wrapper::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 4px;
}

.scrollable-content {
  height: 100%;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .sidebar-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: white;
    z-index: 10000;
    padding: 20px;
  }

  .sidebar-content {
    max-height: calc(100vh - 40px);
    overflow-y: auto;
  }

  .content-wrapper {
    flex-direction: column;
  }

  .toggle-btn {
    position: relative;
    z-index: 10001;
  }

  .move-top-right {
    position: absolute;
    top: -60px;
    right: 20px;
    z-index: 10001;
  }
}
</style>
